import { useMutation, useQueryClient } from "@tanstack/react-query";
import { pathPickBasketMutationApi } from "@/features/pathpick/features/basket/api/mutation";
import { PathPickNaverPartnerConnectRequestBody } from "@/features/pathpick/features/basket/types/request-body";
import useCompanyIdentity from "@/shared/hooks/useCompanyIdentity";
import useAppToasts from "@/features/line-sheet-sets/hooks/use-app-toasts";

// 네이버 제휴 연결 — 판매자ID를 직접 입력해 연결한다.
// 성공 안내 UI는 호출부가 담당하고, 여기서는 연결 상태와 주소록 조회를 무효화한다.
// (주소록은 연결된 계정의 스마트스토어에서 읽어오므로 계정이 바뀌면 이전 값이 무효다)
const useConnectNaverPartner = () => {
  const { companyId } = useCompanyIdentity();
  const queryClient = useQueryClient();
  const { error } = useAppToasts({ id: "GLOBAL", withServerMessage: true });

  return useMutation({
    mutationFn: (body: PathPickNaverPartnerConnectRequestBody) =>
      pathPickBasketMutationApi.connectNaverPartner(companyId as number, body),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["pathpick", "naver-partner-status", companyId],
      });
      queryClient.invalidateQueries({
        queryKey: ["pathpick", "naver-partner-address-books", companyId],
      });
    },
    onError: (err) => {
      error(err);
    },
  });
};

export default useConnectNaverPartner;
